

// compare(oldObj, newObj)
export const reconcile = (oldList, newList, compare) => {
    const old1 = oldList.map((oldObj, i) => ({oldObj, oldIndex: i}));
    const new1 = new Array(newList.length);
    let skipIndex = 0; // For performance boost

    const oldLength = old1.length;
    const newLength = new1.length;
    L1:
    for (let i = 0; i < newLength; i++) {
        const newObj = newList[i];
        for (let j = skipIndex; j < oldLength; j++) {
            if (compare(old1[j].oldObj, newObj)) {
                new1[i] = old1[j];

                if (j > skipIndex) {
                    old1[j] = old1[skipIndex];
                }
                skipIndex++;

                continue L1;
            }
        }
        new1[i] = {newObj};
    }
    return {
        updates: new1,
        removes: skipIndex === 0 ? old1 : old1.slice(skipIndex),
    };
};

// // Compare 2 lists of keys then mark actions to move, remove, or add new
// // input: [key1, key2],
// // returns {updates: [{oldObj:key, oldIndex: 0}, {newObj:key}],removes: [{oldObj:key, oldIndex}]}
// export const reconcile1 = (oldList, newList) => {
//     return reconcile1(oldList, newList, (v1,v2) => v1===v2);
// };


//
// (() => {
//     console.log(JSON.stringify(reconcile([1,2,3], [3,4,1]))) // {"updates":[{"oldObj":3,"oldIndex":2},{"newObj":4},{"oldObj":1,"oldIndex":0}],"removes":[{"oldObj":2,"oldIndex":1}]}
//     // console.log(reconcile([1,2,3], [2,3])) // {"updates":[{"oldObj":3,"oldIndex":2},{"newObj":4},{"oldObj":1,"oldIndex":0}],"removes":[{"oldObj":2,"oldIndex":1}]}
//     // console.log(reconcile([1,2,3], [1,2,3])) // {"updates":[{"key":1,"oldIndex":0},{"key":2,"oldIndex":1},{"key":3,"oldIndex":2}],"removes":[]}
//     // console.log(JSON.stringify(reconcile([1,2,3], [4,5,6]))) // {"updates":[{"newObj":4},{"newObj":5},{"newObj":6}],"removes":[{"oldObj":1,"oldIndex":0},{"oldObj":2,"oldIndex":1},{"oldObj":3,"oldIndex":2}]}
//     // console.log(JSON.stringify(reconcile([1,2,3], []))) // {"updates":[],"removes":[{"oldObj":1,"oldIndex":0},{"oldObj":2,"oldIndex":1},{"oldObj":3,"oldIndex":2}]}
//
// })()
